import '@up2promo-setup-frontend/styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Initialize API client before anything else
import './core/lib/api-client';

import App from './App';
import { RootErrorBoundary } from './components/error-boundary';
import { initPosthog } from './core/posthog-init';

initPosthog();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <RootErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RootErrorBoundary>
  </StrictMode>,
);
